/**
 * A unique-enough id for something that only lives in this browser tab.
 *
 * `crypto.randomUUID` exists only in a secure context, so on a dev server
 * reached over plain HTTP by anything other than `localhost` - a LAN address,
 * or the `.nip.io` hostname this project uses so a browser extension can reach
 * it - the call throws `TypeError` rather than returning undefined.
 *
 * That has bitten this codebase twice. Once in the toast store, where the
 * throw happened on the first line of most mutation success handlers and took
 * the rest of the handler with it, so drawers stopped closing after a save.
 * Once in the identity-document field, where "Add another ID" silently did
 * nothing because the exception was swallowed by React's event handling.
 * Neither failed loudly; both looked like dead buttons.
 *
 * These ids never leave the tab - they are React keys and toast handles - so
 * the fallback only has to be unique within one page's lifetime.
 */
export function randomId(prefix = 'id'): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `${prefix}-${String(Date.now())}-${Math.random().toString(36).slice(2, 10)}`;
}
